export const DOMAIN_COVERAGE_REQUEST = 'DOMAIN_COVERAGE_REQUEST';
export const DOMAIN_COVERAGE_SUCCESS = 'DOMAIN_COVERAGE_SUCCESS';
export const DOMAIN_COVERAGE_FAILURE = 'DOMAIN_COVERAGE_FAILURE';
